import React, { Profiler, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Dropdown } from 'primereact/dropdown'
import { UseInput } from '../../../common/UseInput'
import {
	DIMENSION_UNIT_SELECT_ITEMS,
	LANGUAGES,
	MILESTONES,
	USER_ACCOUNT_STATUS,
	USER_TYPES,
	WEIGHT_UNIT_SELECT_ITEMS,
	ACCOUNT_DISABLED_FLAG,
	USER_PRIVLILEGES,
	PAGE_PRIMARY_CATEGORY,
	PAGE_SUB_CATEGORY1,
} from '../../../constants'
import { COUNTRY_CODES } from '../../../constants/countryCodes'
import {
	getUserProfile,
	updateUser,
	getNotificationSubscription,
	saveNotificationSubscription
} from '../../../services/userProfileService'
import LoadingIndicator from '../../LoadingIndicator'
import {
	addAllNotifications,
	getCountryCode,
	getLoggedInUserProfile,
	getPhoneNo,
	getStatus,
	handleMilestone,
	validateMobileCountryCode,
	validateMobileNumber,
	validateName,
	validatePhoneCountryCode,
	validatePhoneNumber,
	getPrivileges,
	getRoles,
	getPortalUserType,
	addAllPrivileges,
} from '../userManagementUtil'
import { sort } from '../../../utils/common'
import CountryCodeDropdown from '../CountryCodeDropdown/index'
import { useTranslation } from 'react-i18next'
import Messages from '../../../constants/Messages'
import MESSAGES from '../../../constants/Messages'
import { MULTILANGUAGE_SUPPORT_ENABLED } from '../../../configs/featureControlConfig'
import { addError, pushPageData } from '../../../utils/analytics'
import pageNames from '../../../constants/pageNames'
import CommonInput from '../../../common/Resusable/CommonInput'
import { COUNTRY_DATA } from '../../../constants/countryData'
import { CommonDropDown } from '../../../common/Resusable/CommonDropDown'
import { PrimaryButton, SecondaryButton } from '../../../common/Buttons'
const UpdateUserForm = ({
	userCode,
	setUpdateUser,
	setUpdateUserSuccess,
	updateUserSuccess,
	listUsers,
}) => {
	const { t, i18n } = useTranslation(['labels', 'errors'])
	const {
		value: firstName,
		setValue: setFirstName,
		bind: bindFirstName,
		reset: resetFirstName,
	} = UseInput('', { noSpaceValidation: true })
	const {
		value: lastName,
		setValue: setLastName,
		bind: bindLastName,
		reset: resetLastName,
	} = UseInput('', { noSpaceValidation: true })
	const {
		value: phoneNumber,
		setValue: setPhoneNumber,
		bind: bindPhoneNumber,
		reset: resetPhoneNumber,
	} = UseInput('', { noSpaceValidation: true })
	const {
		value: mobileNumber,
		setValue: setMobileNumber,
		bind: bindMobileNumber,
		reset: resetMobileNumber,
	} = UseInput('', { noSpaceValidation: true })

	const {
		value: agentCode,
		setValue: setAgentCode,
		bind: bindAgentCode,
		reset: resetAgentCode,
	} = UseInput('')

	const {
		value: exstStationCode,
		setValue: setExstStationCode,
		bind: bindExstStationCode,
		reset: resetExstStationCode,
	} = UseInput('')

	const [userType, setUserType] = useState('')
	const [userInitialStatus, setUserInitialStatus] = useState('')
	const [userStatus, setUserStatus] = useState('')
	const [language, setLanguage] = useState('')
	const [milestones, setMilestones] = useState({})
	const [notifications, setNotifications] = useState([])
	const [notificationsSub, setNotificationsSub] = useState([])

	const [error, setError] = useState(null)
	const [isLoading, setIsLoading] = useState(false)

	const [userProfile, setUserProfile] = useState(null)

	const [phContryCode, setPhContryCode] = useState('')
	const [mobContryCode, setMobContryCode] = useState('')

	const [privileges, setPrivileges] = useState({
		bookingPrivilege: false,
		capturePrivilege: false,
		dashBoardPrivilege: false,
		informaticsPrivilege: false,
		allotmentPrivilege: false,
	})

	const [preferences, setPrefences] = useState({
		weightUnit: 'K',
		dimensionUnit: 'C',
		language: 'en_US',
	})

	const [privilegeToDisable, setPrivilegeTodisable] = useState(false)
	const [sotedCountryCodes, setSotedCountryCodes] = useState([])
	const [enableAllPrivileges, setEnableAllPrivileges] = useState(false)
	useEffect(() => {
		getUserDetails()
		setUpdateUserSuccess({
			...updateUserSuccess,
			success: false,
			message: '',
		})

		setSotedCountryCodes(sort(COUNTRY_DATA))
	}, [])
	// useEffect(() => {
	// 	if (userType) {
	// 		if (userType === 'KU') {
	// 			setPrivilegeTodisable(true)
	// 			setPrivileges({
	// 				...privileges,
	// 				bookingPrivilege: true,
	// 				capturePrivilege: true,
	// 				dashBoardPrivilege: true,
	// 				informaticsPrivilege: true,
	// 				allotmentPrivilege: true,
	// 			})
	// 		} else {
	// 			setPrivilegeTodisable(false)
	// 		}
	// 	}
	// }, [userType])
	useEffect(() => {
		if (userType) {
			if (userType) {
				setPrivilegeTodisable(true)
				setPrivileges({
					...privileges,
					bookingPrivilege: true,
					capturePrivilege: true,
					dashBoardPrivilege: true,
					informaticsPrivilege: true,
					allotmentPrivilege: true,
				})
			} else {
				setPrivilegeTodisable(false)
			}
		}
	}, [userType])

	useEffect(() => {
		if (notifications) {
			if (addAllNotifications(notifications)) {
				setMilestones((prevState) => ({
					...prevState,
					milestone1: true,
				}))
			} else {
				setMilestones((prevState) => ({
					...prevState,
					milestone1: false,
				}))
			}
		}
	}, [notifications])

	useEffect(() => {
		if (privileges) {
			if (addAllPrivileges(privileges)) {
				setEnableAllPrivileges(true)
			} else {
				setEnableAllPrivileges(false)
			}
		}
	}, [privileges])

	useEffect(() => {
		; (async () => {
			setIsLoading(true)
			try {
				if (userProfile) {
					console.log('userProfileuserProfileuserProfile');
					const response = await getNotificationSubscription(userProfile.agentCode, userProfile.userId)
					const notificationMilestones = []
					if (response && response.userId) {
						console.log('response', response);
						if (response.accepted) {
							notificationMilestones.push('Accepted')
						}
						if (response.departed) {
							notificationMilestones.push('Departed')
						}
						if (response.arrived) {
							notificationMilestones.push('Arrived')
						}
						if (response.notified) {
							notificationMilestones.push('Notified')
						}
						if (response.delivered) {
							notificationMilestones.push('Delivered')
						}
					}
					setNotifications(notificationMilestones)
					setNotificationsSub(notificationMilestones)
					console.log('notificationMilestones', notificationMilestones);
					MILESTONES.forEach(function (milestone, index, array) {

						if (notificationMilestones.includes(milestone.label)) {
							setMilestones((prevState) => ({
								...prevState,
								[milestone.id]: true,
							}))
						}

					})
				}

			} catch (error) {
				console.log(error)
			} finally {
				setIsLoading(false)
			}
		})()
	}, [userProfile])

	const getUserDetails = () => {
		setIsLoading(true)
		getUserProfile({ userCode: userCode !== undefined ? userCode : null })
			.then((response) => {
				setIsLoading(false)
				if (
					response.errorDetails !== undefined &&
					response.errorDetails !== null
				) {
					setUpdateUserSuccess({
						...updateUserSuccess,
						success: false,
						message: `${Messages.USER_CREATION_FAILED} - ${response.errorDetails[0].errorDescription}`,
					})
					addError(
						'ER105',
						i18n.getResource('en', 'errors', MESSAGES.USER_CREATION_FAILED)
					)
					pushPageData(
						pageNames.USER_UPDATE,
						PAGE_PRIMARY_CATEGORY.USER_PROFILE,
						PAGE_SUB_CATEGORY1.USER_MANAGEMENT
					)
				} else {
					setUserProfileDetails(response.userDetails)
					pushPageData(
						pageNames.USER_UPDATE,
						PAGE_PRIMARY_CATEGORY.USER_PROFILE,
						PAGE_SUB_CATEGORY1.USER_MANAGEMENT
					)
				}
			})
			.catch((error) => {
				console.log(error)
				addError(
					'ER105',
					i18n.getResource('en', 'errors', MESSAGES.USER_CREATION_FAILED)
				)
				pushPageData(
					pageNames.USER_UPDATE,
					PAGE_PRIMARY_CATEGORY.USER_PROFILE,
					PAGE_SUB_CATEGORY1.USER_MANAGEMENT
				)
			})
	}

	const setUserProfileDetails = (response) => {
		setUserProfile(response)
		setFirstName(response.firstName)
		setLastName(response.lastName)

		setPhoneNumber(getPhoneNo(response.telephoneNo))
		setPhContryCode(getCountryCode(response.telephoneNo))
		setMobileNumber(getPhoneNo(response.mobileNo))
		setMobContryCode(getCountryCode(response.mobileNo))
		setUserStatus(getStatus(response))
		setUserInitialStatus(getStatus(response))
		setUserType(response.userType)

		setAgentCode(response.agentCode)
		setExstStationCode(response.stationCode);

		if (response.preference) {
			setPrefences((prevState) => ({
				...prevState,
				weightUnit: response.preference.weightUnit,
				dimensionUnit: response.preference.dimensionUnit,
				language: MULTILANGUAGE_SUPPORT_ENABLED
					? response.preference.language
					: 'en_US',
			}))
			setPrefences((prevState) => ({
				...prevState,
				dimensionUnit: response.preference.dimensionUnit,
			}))
		}

		if (response.roles && response.roles.length) {
			getPrivileges(response.roles, privileges, setPrivileges)
		}
	}

	const validateForm = async () => {
		const fNameValid = await validateName(
			firstName,
			'firstName',
			setError,
			error
		)
		const lNameValid = await validateName(lastName, 'lastName', setError, error)
		const phNoValid = await validatePhoneNumber(
			phoneNumber,
			phContryCode,
			setError,
			error
		)
		const mobNoValid = await validateMobileNumber(
			mobileNumber,
			mobContryCode,
			setError,
			error
		)
		const phnCountryCodeValid = validatePhoneCountryCode(
			phContryCode,
			phoneNumber,
			setError
		)
		const mobCountryCodeValid = validateMobileCountryCode(
			mobContryCode,
			mobileNumber,
			setError
		)
		if (
			fNameValid &&
			lNameValid &&
			phNoValid &&
			phnCountryCodeValid &&
			mobCountryCodeValid &&
			mobNoValid
		) {
			setIsLoading(true)
			const responseData = await updateUser(getRequest())
				.then((response) => {
					setIsLoading(false)
					setUpdateUser(false)
					if (response.errorDetails && response.errorDetails.length > 0) {

						return null
					} else {
						return response
					}
				})
				.catch((error) => {
					setUpdateUser(false)
					setIsLoading(false)
					setUpdateUserSuccess({
						...updateUserSuccess,
						success: false,
						message: Messages.USER_UPDATE_FAILED,
					})
					addError(
						'ER106',
						i18n.getResource('en', 'errors', MESSAGES.USER_UPDATE_FAILED)
					)
					getUserDetails()
					return null
				})
			if (responseData) {
				let saveNotifStatus = true
				try {
					const saveNotifResp = await saveNotificationSubscription(getNotificationSubscribeRequest())
					if (saveNotifResp && saveNotifResp?.status === 'F') {
						saveNotifStatus = false
					}
				} catch (error) {
					saveNotifStatus = false
				}
				setUpdateUser(false)
				setUpdateUserSuccess({
					...updateUserSuccess,
					success: true,
					message: t(Messages.USER_UPDATE_SUCCESS, {
						userName: `${firstName} ${lastName}`,
						ns: 'errors',
					}),
					saveNotifConfig: saveNotifStatus,
					saveNotifMessage: !saveNotifStatus ? Messages.USER_PROFILE_SAVE_NOTIFICATION_FAILED : '',
				})
				if (listUsers) {
					listUsers();
				}
				getUserDetails()
			}
		} else {
			console.log('has form error', error)
		}
	}

	const handleSubmit = (evt) => {
		evt.preventDefault()
		validateForm()
	}

	const onChangeUserType = (event) => {
		setUserType(event.target.value)
	}

	const onChangeStatus = (event) => {
		setUserStatus(event.target.value)
	}

	const onChangeLanguage = (event) => {
		setPrefences({ ...preferences, language: event.target.value })
	}

	const onChangeWeightUnit = (event) => {
		setPrefences({ ...preferences, weightUnit: event.target.value })
	}

	const onChangeDimensionUnit = (event) => {
		setPrefences({ ...preferences, dimensionUnit: event.target.value })
	}

	const handleChangeMilestone = (event) => {
		if (event.target.id === 'milestone1') {
			MILESTONES.map((milestone) => {
				setMilestones((prevState) => ({
					...prevState,
					[milestone.id]: true,
				}))
			})
		}
		handleMilestone(event, notifications, setNotifications, setMilestones)
	}

	const handleCancelAction = () => {
		setUpdateUser(false)
		window.scrollTo(0, 0)
	}

	/*Privilege Management*/
	const handleChangePrivileges = (evnt) => {
		const key = evnt.target.id
		const isChecked = evnt.target.checked
		isChecked ? setEnableAllPrivileges(true) : setEnableAllPrivileges(false)
		if (key === 'allPrivileges') {
			setPrivileges((prevState) => ({
				...prevState,
				bookingPrivilege: isChecked,
				capturePrivilege: isChecked,
				dashBoardPrivilege: isChecked,
				informaticsPrivilege: isChecked,
				allotmentPrivilege: isChecked,
			}))
		}
		if (key === 'dashBoardPrivilege' && !isChecked) {
			setPrivileges((prevState) => ({
				...prevState,
				dashBoardPrivilege: isChecked,
				informaticsPrivilege: isChecked,
				allotmentPrivilege: isChecked,
			}))
		} else {
			setPrivileges((prevState) => ({
				...prevState,
				[key]: isChecked,
			}))
		}
	}

	const onChangePhCountryCode = (selectedItem) => {
		setPhContryCode(selectedItem.code);
	}

	const onChangeMobCountryCode = (selectedItem) => {
		setMobContryCode(selectedItem.code);
	}

	const removeError = (event) => {
		const id = event.target.id + ''
		setError((prevState) => ({ ...prevState, [id]: '' }))
	}

	const hasError = (key) => {
		if (error !== null && error[key] && error[key] !== '') {
			return true
		} else {
			return false
		}
	}

	const getRequest = () => {
		const loggedInUserProfile = getLoggedInUserProfile()
		const roles = getRoles(privileges)
		const requestBody = {
			requestId: Math.floor(Math.random() * 89999 + 10000),
			userDetails: {
				userId: userProfile.userId,
				firstName,
				middleName: userProfile.middleName,
				lastName,
				email: userProfile.email,
				telephoneNo:
					phContryCode !== '' && phoneNumber !== ''
						? `${phContryCode} ${phoneNumber}`
						: null,
				mobileNo:
					mobContryCode !== '' && mobileNumber !== ''
						? `${mobContryCode} ${mobileNumber}`
						: null,
				//agentCode: loggedInUserProfile.agentCode,

				agentCode: agentCode,

				customerCode: userProfile?.customerCode ? userProfile.customerCode : null,
				companyName: userProfile.companyName,
				companyCode: userProfile.companyCode,
				statusChanged: userInitialStatus === userStatus ? false : true,
				accountDisabledFlag: userStatus === 'I' ? 'Y' : 'N',
				address: userProfile.address,
				city: userProfile.city,
				state: userProfile.state,
				country: userProfile.country,
				postalCode: userProfile.postalCode,
				stationCode: userProfile.stationCode,
				defaultAirportCode: userProfile.defaultAirportCode,
				weightUnit: userProfile.weightUnit,
				dimensionUnit: userProfile.dimensionUnit,
				userType: userType,
				preference: preferences,
				roles: roles.length ? roles : null,
				// roleGroup:
				// 	userType != null
				// 		? userType === 'KU'
				// 			? 'PORADMUSR'
				// 			: 'PORBKGUSR'
				// 		: null,
				notificationDetails: {
					notificationAction: notifications,
					notificationEmail: [userProfile.email],
					notificationPhoneNo:
						mobContryCode && mobileNumber
							? [`${mobContryCode} ${mobileNumber}`]
							: null,
				},
			},
		}
		return requestBody
	}

	const getNotificationSubscribeRequest = () => {
		const requestBody = {
			agentCode: agentCode,
			userId: userProfile.userId,
			userType: userType,
			email: userProfile.email,
			station: userProfile.defaultAirportCode,
			status: userProfile.status,
			accepted: notifications && notifications.includes('Accepted'),
			departed: notifications && notifications.includes('Departed'),
			arrived: notifications && notifications.includes('Arrived'),
			notified: notifications && notifications.includes('Notified'),
			delivered: notifications && notifications.includes('Delivered')
		}
		return requestBody
	}

	const handleAlertClose = () => {
		setUpdateUserSuccess({
			...updateUserSuccess,
			success: false,
			message: '',
		})
	}

	const triggerPhoneCodeValidation = () => {
		validatePhoneCountryCode(phContryCode, phoneNumber, setError)
	}

	const triggerMobPhoneCodeValidation = () => {
		validateMobileCountryCode(mobContryCode, mobileNumber, setError)
	}

	return (
		<div className='update-user-panel'>
			{isLoading ? <LoadingIndicator /> : <></>}
			{userProfile && (
				<div>
					<div className='form-row '>
						<div className='col-12 col-md-8'>
							<h3 className='heading mt-0'>{t('COMMON.USER_INFO')}</h3>
						</div>
						{userProfile.lastLoginTime && (
							<div className='col-12 col-md-4'>
								<span className='userLastLogin'>
									{t('COMMON.LAST_LOGIN')} : {userProfile.lastLoginTime}{' '}
								</span>
							</div>
						)}
					</div>
					<div className='user-info'>
						<div className='form-row pl-2 mb-0'>
							<div
								className='form-item form-item--text form-item--disabled mb-0'
								data-module='molecules/form-item/FormItem'
							>
								{/* <label className='form-item__label'>
									{t('COMMON.USER_ID')}
								</label> */}
								<CommonInput
									type='text'
									label={t('COMMON.USER_ID')}
									className='form-item__field'
									value={userProfile.userId}
									maxLength='25'
									readOnly
								/>
							</div>
							<div
								className='form-item form-item--text form-item--disabled mb-0'
								data-module='molecules/form-item/FormItem'
							>
								{/* <label className='form-item__label'>{t('COMMON.EMAIL')}</label> */}
								<CommonInput
									type='text'
									label={t('COMMON.EMAIL')}
									className='form-item__field'
									value={userProfile.email}
									maxLength='100'
									readOnly
								/>
							</div>
						</div>
						<div className='form-row pl-2'>
							<div
								className={`form-item form-item--text mb-0 ${error && error['mobileNumber'] ? 'red-border' : ''}`}


								data-module='molecules/form-item/FormItem'
							>

								<CommonInput
									id='firstName'
									type='text'
									label={t('COMMON.FIRST_NAME')}
									{...bindFirstName}
									className='form-item__field'
									maxLength='20'
									aria-invalid={hasError('firstName')}
									onFocus={removeError}
									onBlur={(e) => {
										validateName(firstName, 'firstName', setError, error)
									}}
									error={error && error['firstName']
										? t(error['firstName'], { ns: 'errors' })
										: ''}
								/>

							</div>
							<div
								className={`form-item form-item--text mb-0 ${error && error['mobileNumber'] ? 'red-border' : ''}`}

								data-module='molecules/form-item/FormItem'
							>
								<CommonInput
									id='lastName'
									type='text'
									label={t('COMMON.LAST_NAME')}
									{...bindLastName}
									className='form-item__field'
									maxLength='20'
									aria-invalid={hasError('lastName')}
									onFocus={removeError}
									onBlur={(e) => {
										validateName(lastName, 'lastName', setError, error)
									}}
									error={error && error['lastName']
										? t(error['lastName'], { ns: 'errors' })
										: ''}
								/>
								{/* <label className='form-item__label'>
									{t('COMMON.LAST_NAME')}
								</label> */}
								{/* <span className='form-item__error'>
									{error && error['lastName']
										? t(error['lastName'], { ns: 'errors' })
										: ''}
								</span> */}
							</div>
						</div>
						<div className='user-status-form-row mb-0'>
							<div className='form-item pl-0 mb-0'>
								<CommonDropDown
									label={t('COMMON.ACCOUNT_TYPE')}
									value={getPortalUserType(userType)}
									options={USER_TYPES}
									onChange={onChangeUserType}

								/>
							</div>

							<div className='form-item status  mb-0'>

								<CommonDropDown
									value={userStatus}
									label={t('COMMON.STATUS')}
									options={USER_ACCOUNT_STATUS}
									onChange={onChangeStatus}
								></CommonDropDown>
							</div>
						</div>

						<div className='form-row pl-2'>
							<div
								className='form-item form-item--text form-item--disabled mb-0'
								data-module='molecules/form-item/FormItem'
							>
								{/* <label className='form-item__label'>
									{t('COMMON.AGT_CODE')}
								</label> */}
								<CommonInput
									disabled="true"
									id='agentcode'
									label={t('COMMON.AGT_CODE')}
									type='text'
									{...bindAgentCode}
									className='form-item__field'

								/>
							</div>
							<div
								className='form-item form-item--text form-item--disabled mb-0'
								data-module='molecules/form-item/FormItem'
							>
								{/* <label className='form-item__label'>
									{t('COMMON.STATION_CODE')}
								</label> */}
								<CommonInput
									disabled="true"
									id='stationCode'
									label={t('COMMON.STATION_CODE')}
									type='text'
									{...bindExstStationCode}
									className='form-item__field'
								//maxLength='20'
								/>
							</div>
						</div>

						<div className='privileges-row user-privileges add-account pl-2 mb-0'>
							<label className='form-item__label previlege_heading'>{t('UM.PRIVILEGES')}</label>
							<div className='form-row'>
								<div className='previlege_label col-12 col-lg-auto'>
									<div
										className='form-item l-checkbox'
										data-module='molecules/form-item/FormItem'
									>
										<input
											id='allPrivileges'
											checked={enableAllPrivileges}
											value={enableAllPrivileges}
											disabled={privilegeToDisable}
											type='checkbox'
											name='allPrivileges'
											onChange={handleChangePrivileges}
										/>
										<label
											htmlFor='allPrivileges'
											className='form-item__label'
										>
											{t('COMMON.ALL')}
										</label>
									</div>
								</div>
								<div className='previlege_label col-12 col-lg-auto'>
									<div
										className='form-item l-checkbox'
										data-module='molecules/form-item/FormItem'
									>
										<input
											id='bookingPrivilege'
											checked={privileges.bookingPrivilege}
											value={privileges.bookingPrivilege}
											type='checkbox'
											disabled={privilegeToDisable}
											name='bookingPrivilege'
											onChange={handleChangePrivileges}
										/>
										<label
											htmlFor='bookingPrivilege'
											className='form-item__label'
										>
											{t('COMMON.BKG')}
										</label>
									</div>
								</div>

								<div className='previlege_label col-12 col-lg-auto'>
									<div
										className='form-item l-checkbox'
										data-module='molecules/form-item/FormItem'
									>
										<input
											id='capturePrivilege'
											checked={privileges.capturePrivilege}
											value={privileges.capturePrivilege}
											disabled={privilegeToDisable}
											type='checkbox'
											name='capturePrivilege'
											onChange={handleChangePrivileges}
										/>
										<label
											htmlFor='capturePrivilege'
											className='form-item__label'
										>
											{t('COMMON.DATA_CAPTURE')}
										</label>
									</div>
								</div>

								<div className='previlege_label col-12 col-lg-auto'>
									<div
										className='form-item l-checkbox'
										data-module='molecules/form-item/FormItem'
									>
										<input
											id='dashBoardPrivilege'
											checked={privileges.dashBoardPrivilege}
											value={privileges.dashBoardPrivilege}
											disabled={privilegeToDisable}
											type='checkbox'
											name='dashBoardPrivilege'

											onChange={handleChangePrivileges}
										/>
										<label
											htmlFor='dashBoardPrivilege'
											className='form-item__label'
										>
											{t('UM.DASHBOARD_DEFAULT_PRVLG')}
										</label>
									</div>
								</div>

								<div className='previlege_label col-12 col-lg-auto'>
									<div
										className='form-item l-checkbox'
										data-module='molecules/form-item/FormItem'
									>
										<input
											id='informaticsPrivilege'
											checked={privileges.informaticsPrivilege}
											value={privileges.informaticsPrivilege}
											disabled={
												privilegeToDisable || !privileges.dashBoardPrivilege
											}
											type='checkbox'
											name='informaticsPrivilege'
											onChange={handleChangePrivileges}
										/>
										<label
											htmlFor='informaticsPrivilege'
											className='form-item__label'
										>
											{t('UM.IFOGRPCS_PRVLG')}
										</label>
									</div>
								</div>

								<div className='previlege_label col-12 col-lg-auto'>
									<div
										className='form-item l-checkbox'
										data-module='molecules/form-item/FormItem'
									>
										<input
											id='allotmentPrivilege'
											checked={privileges.allotmentPrivilege}
											value={privileges.allotmentPrivilege}
											disabled={
												privilegeToDisable || !privileges.dashBoardPrivilege
											}
											type='checkbox'
											name='allotmentPrivilege'
											onChange={handleChangePrivileges}
										/>
										<label
											htmlFor='allotmentPrivilege'
											className='form-item__label'
										>
											{t('UM.ALLOTMNT_PRVLG')}
										</label>
									</div>
								</div>
							</div>
						</div>

						<div className='form-row'>
							<div
								className="col-12 col-lg-4 d-block d-md-none"
								data-module="molecules/form-item/FormItem"
							>
								<div className="combined-phone-input d-flex align-items-end">
									<div
										className={`country-dropdown-wrapper ${error && error['phContryCode'] ? 'red-border' : ''}`}
									>
										<CountryCodeDropdown
											id="phContryCode"
											name="phContryCode"
											countryCodes={sotedCountryCodes}
											userCountryCode={phContryCode}
											setCountryCode={onChangePhCountryCode}
											triggerCodeValidation={triggerPhoneCodeValidation}
											setError={setError}
											removeError={removeError}
										/>
										<span className="form-item__error">
											{error && error['phContryCode']
												? t(error['phContryCode'], { ns: 'errors' })
												: ''}
										</span>
									</div>
									<div className="form-group flex-grow-1 phone-input-wrapper">
										<CommonInput
											type="text"
											id="phoneNumber"
											label={t('CREATEUSER.PHONE_NO')}
											{...bindPhoneNumber}
											className="form-item__field"
											maxLength="15"
											aria-invalid={hasError('phoneNumber')}
											onFocus={removeError}
											onBlur={(e) => {
												validatePhoneNumber(phoneNumber, phContryCode, setError, error);
											}}
											error={
												error && error['phoneNumber']
													? t(error['phoneNumber'], { ns: 'errors' })
													: ''
											}
										/>
									</div>
								</div>
							</div>

							<div
								className="col-12 col-lg-4"
								data-module="molecules/form-item/FormItem"
							>
								<div className="combined-phone-input d-flex align-items-end">
									<div
										className={`country-dropdown-wrapper ${error && error['mobContryCode'] ? 'red-border' : ''}`}
									>
										<CountryCodeDropdown
											id="mobContryCode"
											name="mobContryCode"
											autoCompleteType="MOB_COUNTRY_CODE"
											countryCodes={sotedCountryCodes}
											userCountryCode={mobContryCode}
											setCountryCode={onChangeMobCountryCode}
											triggerCodeValidation={triggerMobPhoneCodeValidation}
											setError={setError}
											removeError={removeError}
										/>
										<span className="form-item__error">
											{error && error['mobContryCode']
												? t(error['mobContryCode'], { ns: 'errors' })
												: ''}
										</span>
									</div>

									<div className="form-group flex-grow-1 phone-input-wrapper">
										<CommonInput
											id="mobileNumber"
											type="text"
											label={t('CREATEUSER.MOBILE_NO')}
											{...bindMobileNumber}
											className="form-item__field"
											maxLength="15"
											aria-invalid={hasError('mobileNumber')}
											onFocus={removeError}
											onBlur={(e) => {
												validateMobileNumber(
													mobileNumber,
													mobContryCode,
													setError,
													error
												);
											}}
											error={
												error && error['mobileNumber']
													? t(error['mobileNumber'], { ns: 'errors' })
													: ''
											}
										/>
									</div>
								</div>
							</div>


						</div>
					</div>

					<div>

						<h3 className='heading'>
							{t('COMMON.PREF')}
						</h3>
						<div className='preferences'>
							<div className='form-row'>
								<div className='form-item  pl-2'>
									<CommonDropDown
										label={t('COMMON.LANG')}
										value={preferences.language}
										options={LANGUAGES}
										onChange={onChangeLanguage}
										disabled={!MULTILANGUAGE_SUPPORT_ENABLED}
									></CommonDropDown>
								</div>
							</div>
							<div className='form-row'>
								<div className='form-item pl-2'>
									<CommonDropDown
										label={t('COMMON.WT')}
										value={preferences.weightUnit}
										options={WEIGHT_UNIT_SELECT_ITEMS}

										onChange={onChangeWeightUnit}
										isUpdate={true}
									></CommonDropDown>
								</div>
								<div className='form-item'>
									<CommonDropDown
										label={t('COMMON.DIM')}
										value={preferences.dimensionUnit}
										options={DIMENSION_UNIT_SELECT_ITEMS}

										onChange={onChangeDimensionUnit}
										isUpdate={true}
									></CommonDropDown>
								</div>
							</div>
						</div>
					</div>



					<h3 className='heading'>
						{t('COMMON.NOTIFICATION')}
					</h3>

					<div className='notifications-info'>
						<div className=' form-row notify_list'>
							<div className='col-12 col-md-auto'>
								<div
									className='form-item l-checkbox'
									data-module='molecules/form-item/FormItem'
								>
									<input
										id='milestone1'
										checked={milestones.milestone1}
										value='All'
										type='checkbox'
										name='milestone1'
										onChange={handleChangeMilestone}
									/>
									<label htmlFor='milestone1' className='form-item__label'>
										{t('COMMON.ALL')}
									</label>
								</div>
							</div>
							<div className='col-12 col-md-auto'>
								<div
									className='form-item l-checkbox'
									data-module='molecules/form-item/FormItem'
								>
									<input
										id='milestone3'
										checked={milestones.milestone3}
										value='Departed'
										type='checkbox'
										name='milestone3'
										onChange={handleChangeMilestone}
									/>
									<label htmlFor='milestone3' className='form-item__label'>
										{t('COMMON.DEPARTED')}
									</label>
								</div>
							</div>
							<div className='col-12 col-md-auto'>
								<div
									className='form-item l-checkbox'
									data-module='molecules/form-item/FormItem'
								>
									<input
										id='milestone5'
										checked={milestones.milestone5}
										value='Notified'
										type='checkbox'
										name='milestone5'
										onChange={handleChangeMilestone}
									/>
									<label htmlFor='milestone5' className='form-item__label'>
										{t('COMMON.NOTIFIED')}
									</label>
								</div>
							</div>
							<div className='col-12 col-md-auto'>
								<div
									className='form-item l-checkbox'
									data-module='molecules/form-item/FormItem'
								>
									<input
										id='milestone2'
										checked={milestones.milestone2}
										value='Accepted'
										type='checkbox'
										name='milestone2'
										onChange={handleChangeMilestone}
									/>
									<label htmlFor='milestone2' className='form-item__label'>
										{t('COMMON.ACCEPTED')}
									</label>
								</div>
							</div>

							<div className='col-12 col-md-auto'>
								<div
									className='form-item l-checkbox'
									data-module='molecules/form-item/FormItem'
								>
									<input
										id='milestone4'
										checked={milestones.milestone4}
										value='Arrived'
										type='checkbox'
										name='milestone4'
										onChange={handleChangeMilestone}
									/>
									<label htmlFor='milestone4' className='form-item__label'>
										{t('COMMON.ARRIVED')}
									</label>
								</div>
							</div>

							<div className='col-12 col-md-auto'>
								<div
									className='form-item l-checkbox'
									data-module='molecules/form-item/FormItem'
								>
									<input
										id='milestone6'
										checked={milestones.milestone6}
										value='Delivered'
										type='checkbox'
										name='milestone6'
										onChange={handleChangeMilestone}
									/>
									<label htmlFor='milestone6' className='form-item__label'>
										{t('COMMON.DELIVERED')}
									</label>
								</div>
							</div>
						</div>
					</div>



					<div className='form-row '>
						<div className='cta_wrap flex-row-reverse  custom-ml-1 custom-mt-3 col-12'>
							<PrimaryButton
								onClick={handleSubmit}
								label={t('COMMON.SAVE')}
							/>

							<SecondaryButton
								className="button_cancel custom-ml-4"
								onClick={handleCancelAction}
								label={t('COMMON.CANCEL')}
							/>

						</div>
					</div>
					{/* <div className='form-row'>
				<div className='cta_wrap ml-1 col-12'>
					<button className='primary-button' onClick={handleSubmit}>
						{t('COMMON.SAVE')}
					</button>
					<button
						className='button_cancel secondary-button custom-ml-4'
						onClick={() => setAddUser(false)}
					>
						{t('COMMON.CANCEL')}
					</button>
				</div>
			</div> */}
				</div>
			)}
		</div>
	)
}
const mapStateToProps = ({ loadingDetails }) => ({
	loadingDetails: loadingDetails,
})
const mapDispatchToProps = (dispatch, message) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(UpdateUserForm)
